import React, { useEffect, useMemo, useState } from "react"
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Modal,
  Form,
} from "reactstrap"
import { Link } from "react-router-dom"
// import { useTable, useGlobalFilter, usePagination } from "react-table"
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table"
import { useNavigate } from "react-router-dom"

// css
import "../../../assets/css/Settings/Setting.css"

// commom
import Pagination from "components/Common/Pagination"
import Loader from "pages/Separate/Loader"
import axios from "axios"
import configure from "configure"
import Swal from "sweetalert2"
import NewPagination from "components/Common/Newpagination"

function TableContainer({ columns, data, setLoading, setDatas }) {
  const [modal_center, setmodal_center] = useState(false)
  const [fixedContent, setFixedContent] = useState(false)
  const [addPaymentVia, setAddPaymentVia] = useState("")
  const [addPaymentMode, setAddPaymentMode] = useState("")

  const navigate = useNavigate()

  document.addEventListener("scroll", () => {
    if (window.scrollY > 90) {
      setFixedContent(true)
    } else {
      setFixedContent(false)
    }
  })

  // Center Modal
  function tog_center() {
    setmodal_center(!modal_center)
    removeBodyCss()
  }

  // Use the state and functions returned from useTable to build your UI
  // const {
  //   getTableProps,
  //   getTableBodyProps,
  //   headerGroups,
  //   page,
  //   state,
  //   previousPage,
  //   nextPage,
  //   canPreviousPage,
  //   canNextPage,
  //   gotoPage,
  //   setPageSize,
  //   pageOptions,
  //   setGlobalFilter,
  //   pageCount,
  //   prepareRow,
  // } = useTable(
  //   {
  //     columns,
  //     data,
  //   },
  //   useGlobalFilter,
  //   usePagination
  // )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        sortBy: [
          {
            id: "id",
            desc: true,
          },
        ],
      },
    },

    useGlobalFilter,
    useSortBy,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state
  useEffect(() => setPageSize(50), [])

  const onChangeInInput = event => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0
    gotoPage(page)
  }

  const handleAddForm = async e => {
    e.preventDefault()

    try {
      setLoading(true)
      const formData = new FormData()
      formData.append("user_id", localStorage.getItem("auth_id"))
      formData.append("payment_via", addPaymentVia)
      formData.append("payment_mode", addPaymentMode)

      const response = await axios({
        method: "post",
        url: `${configure.apiUrl}/addFinanceModes`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      if (response) {
        setLoading(false)
        Swal.fire({
          icon: "success",
          text: "Payment mode added successfully !",
        }).then(() => {
          setDatas(response.data.data)
          setAddPaymentVia("")
          setAddPaymentMode("")
          setmodal_center(false)
        })
      }
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  // Render the UI for your table
  return (
    <div>
      <div
        className={`flex-column fixed-buttons ${
          fixedContent ? "d-flex" : "d-none"
        }`}
      >
        <button
          onClick={() => {
            tog_center()
          }}
          className="btn btn-purple  fix-btn"
        >
          <i className="fas fa-plus me-2 icon-size"></i>
          <span>Add</span>
        </button>
        <button onClick={() => navigate(-1)} className="btn btn-red  fix-btn">
          <i className="dripicons-cross me-2 icon-center"></i>
          <span>Cancel</span>
        </button>
      </div>
      <Row className="mb-2">
        <Col>
          <select
            className=" form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(e.target.value)}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
        <Col md={8} className="d-flex justify-content-end">
          <div className="me-4">
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={e => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className=" form-control rounded h-100"
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div className="">
            <button
              onClick={() => {
                tog_center()
              }}
              className=" btn btn-purple btn-label"
            >
              {" "}
              <i className="fas fa-plus me-2 icon-size label-icon"></i>Payment Mode
            </button>
            <button
              onClick={() => navigate(-1)}
              className=" btn ms-md-2 btn-red btn-label"
            >
              <i className="dripicons-cross me-2 icon-center label-icon"></i>CANCEL
            </button>
          </div>
        </Col>
      </Row>
      <Table className="table table-bordered mt-4" {...getTableProps()}>
        <thead className={`${(fixedContent && page.length >= 10) ? "fixed-pay-setting-header" : ""}`}>
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <th
                  key={index}
                  // className={`customShortIcon col-md-${index === 1 || index === 2 ? "4" : "2"}`}
                  className={`${column.className} customShortIcon`}
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                >
                  {column.render("Header")}
                  {column.isInfoIcon ? (
                    <i
                      title="info"
                      className="bx bx-info-circle ms-1 info-icon"
                    ></i>
                  ) : null}

                     {column.isShortIcon && (
                      <span
                        onClick={() =>
                          column.getSortByToggleProps().onClick()
                        }
                        className="ms-2 cursor-pointer"
                      >
                        <i
                          title="Ascending"
                          className={`bi bi-arrow-up info-icon ${
                            column.isSorted && !column.isSortedDesc
                              ? "text-dark"
                              : ""
                          }`}
                        ></i>
                        <i
                          title="Descending"
                          className={`bi bi-arrow-down info-icon ${
                            column.isSorted && column.isSortedDesc
                              ? "text-dark"
                              : ""
                          }`}
                        ></i>
                      </span>
                    )}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        {/* <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <tr className="row-hover" {...row.getRowProps()} key={i}>
                {row.cells.map((cell, index) => {
                  return (
                    <td
                      className={`col-md-${
                        index === 1 || index === 2 ? "4" : "2"
                      }`}
                      key={index}
                      {...cell.getCellProps()}
                    >
                      {cell.render("Cell")}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody> */}
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <tr
                className="row-hover"
                {...row.getRowProps()}
                key={i}
              >
                {row.cells.map((cell, index) => {
                  return (
                    <td
                      className={cell.column.className}
                      key={index}
                      {...cell.getCellProps()}
                    >
                      {cell.render("Cell")}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </Table>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <NewPagination
          gotoPage={gotoPage}
          canPreviousPag={canPreviousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
        />
      </Row>

      {/* Add Department Modal */}
      <Modal
        isOpen={modal_center}
        toggle={() => {
          tog_center()
        }}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Payment Mode</h5>
          <button
            type="button"
            onClick={() => {
              setmodal_center(false)
            }}
            className="btn-modal-close"
          >
            <span className="btn-modal-span">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Form onSubmit={handleAddForm}>
            <Row>
              <div className="col-6">
                <label htmlFor="">
                  Payment Via <span className="text-danger">*</span>
                </label>
                <select
                  required
                  value={addPaymentVia}
                  onChange={e => setAddPaymentVia(e.target.value)}
                  className="form-select "
                >
                  <option value="">Nothing Selected</option>
                  <option value="1">Bank Account</option>
                  <option value="2">Credit Card</option>
                  <option value="3">Others</option>
                </select>
              </div>
              <div className="col-6">
                <label htmlFor="">
                  Payment Mode <span className="text-danger">*</span>
                </label>
                <input
                  required
                  type="text"
                  placeholder="Enter Payment Mode"
                  className="form-control "
                  value={addPaymentMode}
                  onChange={e => setAddPaymentMode(e.target.value)}
                />
              </div>
            </Row>
            <div className="border-bottom my-3"></div>
            <div className="text-end">
            <button className="btn btn-save btn-label">
                  <i className="fas fa-save me-2 label-icon"></i>
                  Submit
                </button>
            </div>
          </Form>
        </div>
      </Modal>
      {/* ------------ */}
    </div>
  )
}

const PaymentMode = () => {
  const [modal_center, setmodal_center] = useState(false)
  const [data, setDatas] = useState([])
  const [isLoading, setLoading] = useState(false)
  const [editId, setEditId] = useState("")
  const [editPaymentVia, setEditPaymentVia] = useState("")
  const [editPaymentMode, setEditPaymentMode] = useState("")

  // Center Modal
  function tog_center() {
    setmodal_center(!modal_center)
  }

  const option = [
    {
      label: "Bank Account",
      value: "1",
    },
    {
      label: "Credit Card",
      value: "2",
    },
    {
      label: "Others",
      value: "3",
    },
  ]

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        isShortIcon: true,
        className: "text-center pay-id"
      },
      {
        Header: "Type",
        accessor: "payment_via",
        isInfoIcon: true,
        isShortIcon: true,
        className: "pay-type",
        Cell: cellProps => {
          const findValue = option?.find(list => {
            return list.value == cellProps.row.original.payment_via
          })
          return <>
          {findValue?.label}
          </>
        },
      },
      {
        Header: "Payment Mode",
        accessor: "payment_mode",
        isInfoIcon: true,
        isShortIcon: true,
        className: "pay-mode",
      },
      {
        Header: "Action",
        accessor: "action",
        className: "text-center pay-action",
        Cell: cellProps => {
          const handleDelete = async () => {
            Swal.fire({
              icon: "warning",
              text: "Are you sure ?",
              showCancelButton: true,
              confirmButtonText: "Yes delete it!",
            }).then(async willDelete => {
              if (willDelete.isConfirmed) {
                try {
                  setLoading(true)
                  const response = await axios({
                    method: "get",
                    url: `${configure.apiUrl}/deleteFinanceModes/${cellProps.row.original.id}`,
                    headers: {
                      Accept: "application/json",
                      "Content-Type": "multipart/form-data",
                    },
                  })
                  if (response) {
                    setLoading(false)
                    Swal.fire({
                      icon: "success",
                      text: "Payment mode deleted successfully.",
                    }).then(() => {
                      setDatas(response.data.data)
                    })
                  }
                } catch (error) {
                  setLoading(false)
                  console.log(error)
                }
              }
            })
          }

          const handleEdit = () => {
            setEditId(cellProps.row.original.id)
            setEditPaymentVia(cellProps.row.original.payment_via)
            setEditPaymentMode(cellProps.row.original.payment_mode)
            setmodal_center(true)
          }
          return (
            <div>
              <button
                onClick={() => {
                  {
                    handleEdit()
                  }
                }}
                className="btn action-btn btn-sm me-1 btn-outline-secondary"
              >
                <i className="fas fa-pencil-alt"></i>
              </button>
              <Link
                onClick={() => handleDelete()}
                to="#"
                className="btn btn-sm action-btn btn-danger"
              >
                <i className="fas fa-trash-alt"></i>
              </Link>
            </div>
          )
        },
      },
    ],
    []
  )

  useEffect(() => {
    fetch()
  }, [])

  const fetch = async () => {
    setLoading(true)
    const formData = new FormData()
    formData.append("user_id", localStorage.getItem("auth_id"))
    try {
      const response = await axios({
        method: "get",
        url: `${configure.apiUrl}/financeModes`,
        // data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(response => {
        setDatas(response.data.data)
        setLoading(false)
      })
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }

  const handleEditForm = async e => {
    e.preventDefault()

    try {
      setLoading(true)
      const formData = new FormData()
      formData.append("user_id", localStorage.getItem("auth_id"))
      formData.append("mode_id", editId)
      formData.append("payment_via", editPaymentVia)
      formData.append("payment_mode", editPaymentMode)

      const response = await axios({
        method: "post",
        url: `${configure.apiUrl}/editFinanceModes`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      if (response) {
        setLoading(false)
        Swal.fire({
          icon: "success",
          text: "Payment mode edited successfully !",
        }).then(() => {
          setDatas(response.data.data)
          setEditId("")
          setmodal_center(false)
        })
      }
    } catch (error) {
      setLoading(false)

      console.log(error)
    }
  }

  return (
    <>
      <div>
        {isLoading && <Loader />}
        <Row className="ms-0 pe-0">
          <Col lg={12} className="p-0">
            <Card>
              <CardBody>
                <TableContainer
                  columns={columns}
                  data={data}
                  setLoading={setLoading}
                  setDatas={setDatas}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      {/* Edit Department Modal */}
      <Modal
        isOpen={modal_center}
        toggle={() => {
          tog_center()
        }}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Payment Mode</h5>
          <button
            type="button"
            onClick={() => {
              setmodal_center(false)
            }}
            className="btn-modal-close"
          >
            <span className="btn-modal-span">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Form onSubmit={handleEditForm}>
            <Row>
              <div className="col-6">
                <label htmlFor="">Payment Via</label>
                <select
                  value={editPaymentVia}
                  onChange={e => setEditPaymentVia(e.target.value)}
                  className="form-select "
                >
                  <option value="0">Nothing Selected</option>
                  <option value="1">Bank Account</option>
                  <option value="2">Credit Card</option>
                  <option value="3">Others</option>
                </select>
              </div>
              <div className="col-6">
                <label htmlFor="">Payment Mode</label>
                <input
                  type="text"
                  placeholder="Enter Payment Mode"
                  className="form-control "
                  value={editPaymentMode}
                  onChange={e => setEditPaymentMode(e.target.value)}
                />
              </div>
            </Row>
            <div className="border-bottom my-3"></div>
            <div className="text-end">
              <button className="btn btn-save btn-label">
                  <i className="fas fa-save me-2 label-icon"></i>
                  Submit
                </button>
            </div>
          </Form>
        </div>
      </Modal>
      {/* ------------ */}
    </>
  )
}

export default PaymentMode
